const expandBtns = document.querySelectorAll('.expandBtn');
const listsToExpand = document.querySelectorAll('.listToExpand');

if (expandBtns && expandBtns.length > 0 && listsToExpand && listsToExpand.length > 0) {
    const itemsWithoutExpand = 10;

    listsToExpand.forEach((list, index) => {
        const expandBtn = expandBtns[index];
        const expandBtnText = expandBtn.querySelector('.expandBtnText');
        const tbody = list.querySelector('tbody');
        const items = Array.prototype.filter.call(
            tbody.childNodes,
            (child) => child.nodeName === 'TR',
        );

        if (items.length > itemsWithoutExpand) {
            const toggleDisplay = () => {
                for (let i = itemsWithoutExpand; i < items.length; i++) {
                    items[i].style.display = 'none';
                }
            };

            const toggleOpacity = () => {
                for (let i = 0; i < items.length; i++) {
                    if (i >= itemsWithoutExpand - 1) {
                        items[i].style.opacity = '0.44';
                    }
                }
            };

            expandBtn.parentElement.style.display = 'flex';

            toggleDisplay();
            toggleOpacity();

            expandBtn.addEventListener('click', () => {
                const btnTexts = {
                    show: 'Rozwiń',
                    hide: 'Zwiń',
                };

                if (expandBtnText.innerText === btnTexts.show) {
                    expandBtnText.innerText = btnTexts.hide;
                    expandBtn.classList.add('rotate-icon');
                    items.forEach((item) => {
                        item.style.display = 'table-row';
                        item.style.opacity = '1';
                    });
                } else {
                    expandBtnText.innerText = btnTexts.show;
                    expandBtn.classList.remove('rotate-icon');
                    toggleDisplay();
                    toggleOpacity();
                }
            });
        } else {
            expandBtn.style.display = 'none';
        }
    });
}
